export default __webpack_public_path__ + "static/media/icon_facebook.6b1eed3c.svg";